/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
 function initProductCardSwipe() {
    if (!document.documentElement.classList.contains('supports-touch')) return;

    document.querySelectorAll('[data-product-block]').forEach(function(card) {
      if (card.dataset.swipeInit) return;
      card.dataset.swipeInit = true;

      var holder = card.querySelector('.product__media__holder');
      var featured = card.querySelector('.product__media__image');
      var hover = card.querySelector('.product__media__hover');

      if (!featured || !hover || !holder) return;

      // Sätt hover-bilden till höger från start
      hover.style.position = 'absolute';
      hover.style.top = '0';
      hover.style.left = '0';
      hover.style.width = '100%';
      hover.style.height = '100%';
      hover.style.transform = 'translateX(100%)';

      // Skapa scrollbar
      var bar = document.createElement('div');
bar.style.cssText = [
  'position:absolute',
  'bottom:0',
  'left:0',
  'width:100%',
  'height:2px',
  'background:rgba(0,0,0,0.15)',
  'z-index:10',
  'opacity:0',
  'transition:opacity 0.3s ease',
  'pointer-events:none'
].join(';');

      var thumb = document.createElement('div');
thumb.style.cssText = [
  'position:absolute',
  'top:0',
  'left:0',
  'width:50%',
  'height:100%',
  'background:rgba(0,0,0,0.55)',
  'transition:none'
].join(';');

      bar.appendChild(thumb);
      holder.appendChild(bar);

      var hideTimer = null;

      function showBar() {
        clearTimeout(hideTimer);
        bar.style.opacity = '1';
      }

      function hideBar() {
        hideTimer = setTimeout(function() {
          bar.style.opacity = '0';
        }, 1200);
      }

      function updateThumb(progress) {
        // progress: 0 = bild 1, 1 = bild 2
        thumb.style.left = (progress * 50) + '%';
      }

      var startX = 0;
      var startY = 0;
      var isTracking = false;
      var isSwipe = false;
      var atSecond = false;
      var cardWidth = 0;

      function setTransition(on) {
        var t = on ? 'transform 0.3s ease' : 'none';
        featured.style.transition = t;
        hover.style.transition = t;
        thumb.style.transition = on ? 'left 0.3s ease' : 'none';
      }

      function snapTo(second) {
        setTransition(true);
        atSecond = second;
        featured.style.transform = second ? 'translateX(-100%)' : 'translateX(0%)';
        hover.style.transform = second ? 'translateX(0%)' : 'translateX(100%)';
        updateThumb(second ? 1 : 0);
        hideBar();
      }

      card.addEventListener('touchstart', function(e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        isTracking = true;
        isSwipe = false;
        cardWidth = card.offsetWidth;
        setTransition(false);
        showBar();
      }, { passive: true });

      card.addEventListener('touchmove', function(e) {
        if (!isTracking) return;

        var dx = e.touches[0].clientX - startX;
        var dy = e.touches[0].clientY - startY;

        if (!isSwipe && Math.abs(dy) > Math.abs(dx)) {
          isTracking = false;
          hideBar();
          return;
        }

        if (Math.abs(dx) > 5) isSwipe = true;
        if (!isSwipe) return;

         e.preventDefault();

        var delta = atSecond ? dx - cardWidth : dx;
        delta = Math.max(-cardWidth, Math.min(0, delta));

        featured.style.transform = 'translateX(' + delta + 'px)';
        hover.style.transform = 'translateX(calc(100% + ' + delta + 'px))';

        // Uppdatera thumb live
        var progress = Math.abs(delta) / cardWidth;
        updateThumb(progress);

      }, { passive: false });

      card.addEventListener('touchend', function(e) {
        if (!isTracking || !isSwipe) return;
        isTracking = false;

        var dx = e.changedTouches[0].clientX - startX;
        var threshold = cardWidth * 0.3;

        if (!atSecond && dx < -threshold) snapTo(true);
        else if (atSecond && dx > threshold) snapTo(false);
        else snapTo(atSecond);

      }, { passive: true });
    });
  }

  document.addEventListener('DOMContentLoaded', initProductCardSwipe);
  document.addEventListener('shopify:section:load', initProductCardSwipe);
  document.addEventListener('theme:load:more', initProductCardSwipe);

  // Bevakar nya produktkort från infinite scroll
var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        initProductCardSwipe();
      }
    });
  });
  
observer.observe(document.body, { childList: true, subtree: true });


/* ════ DORELLE CUSTOM JS ════ */

/* Sort from the sticky bar: the theme re-opens the mobile filters drawer
   after every AJAX sort (mobileFiltersScrollLock). Suppress that, and
   close the sort dropdown after a choice is made. */
document.addEventListener('change', function (e) {
  var bar = document.getElementById('CollectionStickyBar');
  if (!bar || !bar.contains(e.target)) return;
  if (!e.target.hasAttribute('data-input-sort')) return;

  // 1) Close the sort dropdown immediately after choosing
  var dropdown = bar.querySelector('[data-collection-sort-options]');
  if (dropdown) dropdown.classList.remove('collection__sort__option-wrapper--visible');

  // 2) Watch the filters drawer for the next few seconds; if the theme
  //    opens it as a side effect of the sort re-render, close it again
  var filters = document.querySelector('[data-collection-filters]');
  if (!filters) return;

  var observer = new MutationObserver(function () {
    if (filters.classList.contains('collection__filters--visible')) {
      filters.classList.remove('collection__filters--visible');
      document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true, detail: 300 }));
    }
  });
  observer.observe(filters, { attributes: true, attributeFilter: ['class'] });
  setTimeout(function () { observer.disconnect(); }, 3000);
}, true);

/* ── Cart count bubble: live update on cart changes ── */
(function () {
  function updateCartCount(count) {
    document.querySelectorAll('[data-dorelle-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function refreshFromCart() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); })
      .catch(function () {});
  }

  document.addEventListener('theme:cart:update', refreshFromCart);
  document.addEventListener('theme:cart:added', refreshFromCart);
  document.addEventListener('theme:cart:loaded', refreshFromCart);
})();



  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
